import { defaultParamsForNav } from '@/pages/ipe/workbench/constants/ipeWorkflowStorage';
import { MODEL_STUDIO_NAV_IDS } from '@/pages/ipe/workbench/constants/modelStudioConfig';
import { IMAGE_FISSION_VARIATION_COUNT_OPTIONS } from '@/pages/ipe/workbench/constants/imageFissionStudioConfig';

function resolveDefaultNavId(navId) {
  const id = String(navId || '').trim();
  // patternFission 与 imageFission 共用默认尺寸字段；defaultParamsForNav 仅注册了 imageFission
  if (id === 'patternFission') return 'imageFission';
  return id;
}

/** 详情快捷弹窗：按目标功能取默认 studioParams */
export function getDefaultDetailToolBridgeParams(navId) {
  const id = String(navId || '').trim();
  const defaults = defaultParamsForNav(resolveDefaultNavId(id));
  if (id === 'patternFission') {
    return { ...defaults, patternOnly: true };
  }
  return defaults;
}

/**
 * 合并弹窗参数：defaults ← prev ← patch，并对裂变 / 模特 / POD 做轻量规范化。
 * @param {string} navId
 * @param {object} [prev]
 * @param {object} [patch] 可为局部字段
 */
export function mergeDetailToolBridgeParams(navId, prev = {}, patch = {}) {
  const id = String(navId || '').trim();
  const base = prev && typeof prev === 'object' && !Array.isArray(prev) ? { ...prev } : {};
  const delta = patch && typeof patch === 'object' && !Array.isArray(patch) ? patch : {};
  const next = { ...getDefaultDetailToolBridgeParams(id), ...base, ...delta };

  if (id === 'imageFission' || id === 'patternFission') {
    const n = Number(next.variationCount);
    next.variationCount = IMAGE_FISSION_VARIATION_COUNT_OPTIONS.includes(n) ? n : 1;
    if (id === 'patternFission') next.patternOnly = true;
  }
  if (MODEL_STUDIO_NAV_IDS.includes(id)) {
    next.generateCount = Math.max(1, Math.min(4, Number(next.generateCount) || 1));
  }
  if (id === 'podProductDesign') {
    next.imageTemplateIds = (Array.isArray(next.imageTemplateIds) ? next.imageTemplateIds : [])
      .map(String)
      .filter(Boolean);
  }
  return next;
}
